import React from 'react';
import PropTypes from 'prop-types';
import { PhoneRegistrationRelayNumbers } from './PhoneRegistrationRelayNumbers';
import {
  LOADING_STATE_VALUE,
  NO_RELAY_DEFAULTS,
  PHONE_REGISTRATION_COLUMNS,
  REGISTRATION_ATTEMPTS,
  TRACKING_NUMBER_STATUS,
} from '../constants';

const PhoneRegistrationColumnCells = ({
  propertyPhoneRegistrationRelayMap,
  relayPhones,
}) => {
  const noRelayDefaults =
    propertyPhoneRegistrationRelayMap[NO_RELAY_DEFAULTS] || {};

  return PHONE_REGISTRATION_COLUMNS.map((fieldName) => (
    <td className="phone-registration table-data" key={fieldName}>
      {!relayPhones ? (
        noRelayDefaults[fieldName] || LOADING_STATE_VALUE
      ) : (
        <PhoneRegistrationRelayNumbers
          fieldName={fieldName}
          propertyPhoneRegistrationRelayMap={propertyPhoneRegistrationRelayMap}
          relayPhones={relayPhones}
        />
      )}
    </td>
  ));
};

PhoneRegistrationColumnCells.propTypes = {
  propertyPhoneRegistrationRelayMap: PropTypes.objectOf(
    PropTypes.shape({
      [REGISTRATION_ATTEMPTS]: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
      ]),
      [TRACKING_NUMBER_STATUS]: PropTypes.string,
      [NO_RELAY_DEFAULTS]: PropTypes.shape({
        [REGISTRATION_ATTEMPTS]: PropTypes.oneOfType([
          PropTypes.number,
          PropTypes.string,
        ]),
        [TRACKING_NUMBER_STATUS]: PropTypes.string,
      }),
    })
  ),
  relayPhones: PropTypes.arrayOf(
    PropTypes.shape({
      relayPhoneId: PropTypes.number,
      voiceNumber: PropTypes.string,
    })
  ),
};

export default PhoneRegistrationColumnCells;
